import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
@Component({
  selector: 'app-video-dialog',
  templateUrl: './video-dialog.component.html',
  styleUrls: ['./video-dialog.component.scss']
})
export class VideoDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<VideoDialogComponent>,
  @Inject(MAT_DIALOG_DATA) public data: any){

  }

  closeDialog() {
    this.dialogRef.close();
  }

  ngOnInit(): void {
  }

}
